import AppRoutes from '../AppRoutes';
import UploadPhotoStep from '../components/Project/Create/Steps/UploadPhoto';
import AddItemsStep from '../components/Project/Create/Steps/EstimateBudget/AddItems';
import { useLocation, useNavigate } from 'react-router-dom';
import { Home } from '../components/Home';
import ContractorChoose from '../components/Project/Create/Steps/EstimateBudget/Contractor/Choose';

function useProjectSteps () {
    const location = useLocation();
    const navigate = useNavigate();

    const getStep = (component) => {
        return AppRoutes.find(route => route.element?.type?.name === component?.type?.name)
    }

    const steps = [
        getStep(<UploadPhotoStep/>),
        getStep(<AddItemsStep/>),
        getStep(<ContractorChoose />)
    ];

    const rootPath = AppRoutes.find(route => route.element?.type?.name === (<Home/>).type.name)?.path;

    const getCurrentStepIndex = () => {
        return steps.findIndex(step => step.path === location.pathname)
    }

    const goFirstStep = () => {
        const firstStep = steps[0];

        if (firstStep?.path) {
            navigate(firstStep.path);
        }
    }

    const goNextStep = () => {
        let currentIndex = getCurrentStepIndex();
        
        const nextIndex = !isNaN(currentIndex) ? ++currentIndex : -1;
        const nextStep = steps[nextIndex];

        if (nextStep?.path) {
            navigate(nextStep?.path);
        }
    }

    const goPreviousStep = () => {
        let currentIndex = getCurrentStepIndex();
        const prevIndex = !isNaN(currentIndex) ? --currentIndex : -1;
        const prevStep = steps[prevIndex];

        if (prevStep?.path) {
            navigate(prevStep?.path);
        } else {
            goRootPath();
        }
    }

    const goRootPath = () => {
        navigate(rootPath || '/');
    }

    const getFirstStepPath = () => {
        const firstStep = steps[0];

        return firstStep?.path
    }

    return {
        goFirstStep,
        goNextStep,
        goPreviousStep,
        goRootPath,
        getFirstStepPath
    };
}

export default useProjectSteps;
